/**
 * Преобразует загруженный файл в Blob с исходным MIME-типом
 * @param {File} file - Загруженный файл
 * @returns {Blob} - Новый Blob с тем же MIME-типом
 */
export function fileToBlob(file) {
    if (!(file instanceof File)) {
        throw new Error("Передан не файл");
    }
    return new Blob([file], { type: file.type });
}
